import DonationsTable from '@Views/Donations/Components/DonationsTable';
import { useSuspenseQuery } from '@tanstack/react-query';
import { donationsQueryOptions } from '@utils/queryOptions';
import { useLoaderDeps } from '@tanstack/react-router';
import useSort from '@hooks/useSort';
import useCheckedItems from '@hooks/useCheckedItems';

const ContactDonations = () => {
    const { data, refetch } = useSuspenseQuery(
        donationsQueryOptions(useLoaderDeps({})),
    );

    const { results: donations, count } = data || {};

    const { getSort, setSort } = useSort();

    const { checkedItems, handleToggle, setCheckedItems } = useCheckedItems();

    return (
        <>
            <DonationsTable
                donations={donations || []}
                checkedDonations={checkedItems}
                toggleCheckItem={handleToggle}
                setCheckedDonations={setCheckedItems}
                getSort={getSort}
                onSortChange={setSort}
            />
        </>
    );
};

export default ContactDonations;
